import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalVoyageRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.VOYAGES);
  }

  async listByVesselId(vesselId) {
    return this.table.where("vesselId").equals(vesselId).toArray();
  }

  async listByVesselAndStatus(vesselId, status) {
    return this.table.where("[vesselId+status]").equals([vesselId, status]).toArray();
  }
}
